import React from 'react'
import { AppAntSwitch } from "@components"


export default function SearchAnalyticsCustomTableToolbar({ showDateTable, setShowDateTable }) {

	return <AppAntSwitch
		checked={showDateTable}
		onChange={setShowDateTable}
		falseText="Site/Date"
	/>
}